import { jsx as _jsx } from "react/jsx-runtime";
import ResetIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
import { useAttributeGroup } from "./useAttributeGroup";
export function AttributeGroupResetButton(props) {
    const { groupId, groupBehavior } = props;
    const { resetGroup } = useAttributeGroup({ groupId, groupBehavior });
    return _jsx(AttributeGroupResetButtonUi, { resetGroup: resetGroup });
}
function AttributeGroupResetButtonUi(props) {
    const { resetGroup } = props;
    const t = useUiTranslator();
    const title = t("ConfigurationRenderer:AttributeGroup.resetAttributeGroup", "Reset attribute group");
    function handleReset(e) {
        e.preventDefault();
        e.stopPropagation();
        resetGroup();
    }
    return (_jsx(Tooltip, { title: title, children: _jsx(IconButton, { type: "button", "aria-label": title, onClick: handleReset, children: _jsx(ResetIcon, {}) }) }));
}
//# sourceMappingURL=AttributeGroupResetButton.js.map